<template>
  <div class="table">
    <div class="container">
      <el-row>
        <el-button type="primary" size="mini" @click="historyBack">关闭</el-button>
      </el-row>
      <div class="handle-box">

        <el-form :model="headData" :label-position="labelPosition" ref="headDataForm" label-width="140px">
          <el-row :gutter="20">
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('apply.no')">
                <!--单据编号-->
                <el-input class="handle-input" v-model="headData.applyNo" :disabled="true" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('apply.subject')">
                <!--主题-->
                <el-input class="handle-input" v-model="headData.subject" :disabled="true" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item label="入围供应商">
                <el-input class="handle-input" v-model="supplierNames" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('apply.quotationType')">
                <!--报价类型-->
                <ic-select disabled="true" table="TT_QUOTATION_APPLY" class="handle-input" field="QUOTATION_TYPE" v-model="headData.quotationType" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="历史报价" name="line">
          <!--历史报价-->
          <div v-for="(round,i) in roundList" :key="i">
            <el-row :gutter="16">
              <!--轮次-->
              <el-col :span="2">{{$t('apply.round')}}：</el-col>
              <el-col :span="1">{{round.roundNumber}}</el-col>
              <!--报价提交日期-->
              <el-col :span="3">{{$t('apply.quoteSubmitDate')}}：</el-col>
              <el-col :span="3">
                <el-link> {{round.submitDate}} </el-link>
              </el-col>
              <!--轮次说明-->
              <el-col :span="2">{{$t('apply.roundRemark')}}：</el-col>
              <el-col :span="4">{{round.remark}}</el-col>
              <!--轮次附件-->
              <el-col :span="2">
                <el-link type="primary" @click="showAttachmentDialogM($t('apply.roundAttachment'),round.ttQuotationApplyRoundId,'QUOTATION_APPLY_ROUND')">{{$t('apply.roundAttachment')}}</el-link>
              </el-col>
              <!--报价附件-->
              <el-col :span="3">
                <el-link type="primary" @click="showAttachmentDialogM($t('apply.quoteAttachment'),round.ttQuotationId,'QUOTATION',tmSupplierId)">{{$t('apply.quoteAttachment')}}</el-link>
              </el-col>
            </el-row>
            <ux-grid ref="quotationLineTableDataRef" :data="round.quotationProductList" keep-source highlight-current-row max-height="550" show-overflow="tooltip">
              <ux-table-column align="center" title="序号" type="index" width="60"></ux-table-column>
              <ux-table-column align="center" v-for="(item,index) in columns" :key="index" resizable :field="item.prop" :title="item.label" sortable :min-width="item.width" />
              <ux-table-column align="center" resizable field="isSpecialFreight" title="非标准线路运费" sortable min-width="150" :formatter="formatisSpecial" />
              <ux-table-column align="center" v-for="(item,index) in columns1" :key="index" resizable :field="item.prop" :title="item.label" sortable :min-width="item.width" />
            </ux-grid>
          </div>
        </el-tab-pane>
      </el-tabs>

    </div>

    <el-dialog :title="title" :visible.sync="showAttachmentDialog" append-to-body width="60%">
      <el-table :data="attachmentList" border highlight-current-row class="table">
        <el-table-column sortable prop="documentName" label="文件" min-width="130px">
          <template slot-scope="scope">
            <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
          </template>
        </el-table-column>
        <el-table-column sortable prop="userName" label="创建人" min-width="130px"></el-table-column>
        <el-table-column sortable prop="createDate" label="创建时间" min-width="130px">
          <template slot-scope="scope">
            {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { quotationHistoryInit } from "@/api/quoteByProductSup.js";
import { fileService } from "@/api/common/file-utils";
import IcSelect from "@/components/common/icSelect";
export default {
  // name: 'quotation-history',
  components: { IcSelect },
  data() {
    return {
      columns: [
        { prop: "supplierName", label: "供应商", width: "160" },
        { prop: "eightBitCode", label: "8位码", width: "120" },
        { prop: "eightBitCodeName", label: "8位码名称", width: "120" },
        { prop: "pickupPoint", label: "发货市", width: "120" },
        { prop: "dcName", label: "到货仓库", width: "120" },
        { prop: "temperatureI18n", label: "温区", width: "90" },
        { prop: "lineUnit", label: "结算单位", width: "120" },
        { prop: "transportaionMethod", label: "运输方式", width: "120" },
        { prop: "effectiveBeginDate", label: "有效开始日期", width: "150" },
        { prop: "linePrice", label: "线路价格", width: "120" },
      ],
      columns1: [
        { prop: "productPrice", label: "产品运费（不含税）", width: "180" },
        { prop: "currencyCode", label: "币种", width: "100" },
        { prop: "leadTime", label: "LeadTime", width: "140" },
        { prop: "externalPackagingLength", label: "外包装长(cm)", width: "140" },
        { prop: "externalPackagingWidth", label: "外包装宽(cm)", width: "140" },
        { prop: "externalPackagingHeight", label: "外包装高(cm)", width: "140" },
        { prop: "externalPackagingNetweight", label: "外包装净重(kg)", width: "140" },
        { prop: "externalPackagingGrossweight", label: "外包装毛重(kg)", width: "140" },
        { prop: "palletLayerNumber", label: "每Pallet层数", width: "140" },
        { prop: "palletLayerBoxNumber", label: "每层箱数", width: "140" },
        { prop: "remarks", label: "备注", width: "120" },
        { prop: "sourcingProductStatus", label: this.$t('apply.sourcingApprovalStatus'), width: "170" },
      ],
      ttQuotationApplyId: null,
      labelPosition: 'right',
      headData: {},
      quotationLineTableData: [],
      applyTypeList: [],
      quotationTypeList: [],
      fileList: [],
      activeName: 'line',
      roundList: [],

      showAttachmentDialog: false,
      attachmentList: [],
      title: '',
      tmSupplierId: null,
      supplierNames: '',
    }
  },
  created() {
    // this.getInputChoiceValues();
    this.quotationHistoryPageInitM(this.$route.query.applyId);
    this.ttQuotationApplyId = this.$route.query.applyId;
  },
  methods: {
    quotationHistoryPageInitM(applyId) {
      let _this = this;
      quotationHistoryInit(applyId).then((res) => {
        _this.supplierNames = res.supplierNames;
        _this.headData = res.quotationApply;
        _this.roundList = res.roundHistory;
        _this.tmSupplierId = res.tmSupplierId;
      });
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => { })
    },
    //文件列表数据获取
    showAttachmentDialogM: function (title, recId, reckindId, seq) {
      this.showAttachmentDialog = true;
      this.title = title;
      let attachment = {};
      if (!!seq) {
        attachment.seq = seq + '';
      }
      attachment.tsRecId = recId;
      attachment.tsReckindId = reckindId;
      fileService.getFileList(attachment).then((fileRes) => {
        this.attachmentList = fileRes;
      })
    },
    historyBack: function () {
      this.$router.go(-1);
    },
    formatisSpecial: function (row, column) {
      return row.isSpecialFreight == "Y" ? "是" : "否"
    },
  }
}
</script>
<style scoped>
.handle-box {
  margin-top: 10px;
}
.handle-input {
  width: 85%;
}

.handle-input-out {
  width: 70%;
}
.action-btn {
  margin-bottom: 10px;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}

.lineClass .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
</style>
